(function ($) {
    //custom events tracking (FB pixel + G ADS managed via GTM)
    var bookingSelector = $('.bookingform_vertical .submit_wrap input[type=submit], .bookingform_horizontal .submit_wrap input[type=submit]');
    var emailSelector = $('.info_wrap .email a, .item_contacts .element_email .element_data a');
    var spaFormSelector = $('.deform.deform_spa');
    var restaurantFormSelector = $('body.dftLangPostId_41 .deform.deform_restaurant');
    var newsletterFormSelector = $('#newsletter form');
    bookingSelector.on('click', function() {
        fbq('track', 'Check_Availability');
        dataLayer.push({event: 'minaromgallery_clickbook'});
    });
    emailSelector.on('click', function() {
        fbq('track', 'Email_adress_click');
        dataLayer.push({event: 'minaromgallery_clickemail'});
    });
    spaFormSelector.on('deforms_success', function() {
        dataLayer.push({event: 'minaromgallery_submitspaform'});
    });
    restaurantFormSelector.on('deforms_success', function() {
        dataLayer.push({event: 'minaromgallery_submitrestaurantform'});
    });
    newsletterFormSelector.on('submit', function() {
        fbq('track', 'Lead');
        dataLayer.push({event: 'minaromgallery_submitnewsletter'});
    });
})(jQuery);